import { render } from "./TagInput.vue?vue&type=template&id=6e7f2664"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/TagInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e7f2664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e7f2664', __exports__)) {
    api.reload('6e7f2664', __exports__)
  }
  
  module.hot.accept("./TagInput.vue?vue&type=template&id=6e7f2664", () => {
    api.rerender('6e7f2664', render)
  })

}


export default __exports__